import React from 'react';
import PropTypes from 'prop-types';
import Notification from './Notification';

const NotificationContainer = ({
  notification = null,
  position = 'top-right',
  className = ''
}) => {
  const positionClasses = {
    'top-left': 'top-4 left-4',
    'top-right': 'top-4 right-4',
    'top-center': 'top-4 left-1/2 transform -translate-x-1/2',
    'bottom-left': 'bottom-4 left-4',
    'bottom-right': 'bottom-4 right-4',
    'bottom-center': 'bottom-4 left-1/2 transform -translate-x-1/2'
  };

  const containerClasses = {
    'top-left': 'items-start justify-start',
    'top-right': 'items-start justify-end',
    'top-center': 'items-start justify-center',
    'bottom-left': 'items-end justify-start',
    'bottom-right': 'items-end justify-end',
    'bottom-center': 'items-end justify-center'
  };

  // Don't render anything if no notification
  if (!notification) {
    return null;
  }

  return (
    <div
      className={`
        fixed z-50 w-full max-w-sm sm:max-w-md lg:max-w-lg
        ${positionClasses[position]}
        pointer-events-none
      `}
    >
      <div
        className={`
          flex flex-col gap-2 sm:gap-3
          ${containerClasses[position]}
          pointer-events-auto
          ${className}
        `}
      >
        <Notification
          key={notification.id}
          {...notification}
          className="pointer-events-auto"
        />
      </div>
    </div>
  );
};

NotificationContainer.propTypes = {
  notification: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    type: PropTypes.oneOf(['success', 'error', 'warning', 'info']),
    title: PropTypes.string,
    message: PropTypes.string,
    onClose: PropTypes.func,
    showCloseButton: PropTypes.bool,
    iconSize: PropTypes.oneOf(['small', 'default', 'large']),
    variant: PropTypes.oneOf(['default', 'elevated', 'flat', 'outlined'])
  }),
  position: PropTypes.oneOf([
    'top-left',
    'top-right', 
    'top-center',
    'bottom-left',
    'bottom-right',
    'bottom-center'
  ]),
  className: PropTypes.string
};

export default NotificationContainer;
